import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetFilters,
  resetPagination,
  selectAdvertiser,
  selectAllAdvertisers,
  selectAllCountries,
  selectAllSources,
  selectCountry,
  selectSource,
  setDateRange,
  setPageLimit,
} from '../../state/rejects-report/actions';
import DatePicker from '../global/filters/DatePicker';
import ApplyButton from '../global/filters/ApplyButton';
import ResetButton from '../global/filters/ResetButton';
import CommonFilter from '../global/filters/CommonFilter';
import filtersSelector from '../../state/rejects-report/selectors/filter/filters';
import { setRejectsReportData } from '../../state/rejects-report/async-actions';
import pageSelector from '../../state/rejects-report/selectors/page/page';

const FiltersRow = ({ type }) => {
  const { cursor } = useSelector(pageSelector);
  const { advertisers, sources, countries, selectedAdvertisers, selectedSource, selectedDate, selectedCountry } = useSelector(filtersSelector);
  const dispatch = useDispatch()

  const resetFunc = () => {
    dispatch(resetFilters())
  }

  const applyFunc = () => {
  const isFilter = true
  dispatch(resetPagination())
    dispatch(
      setRejectsReportData({
        isFilter,
        type,
        selectedDate,
        selectedAdvertisers,
        selectedSource,
        selectedCountry,
        cursor,
      })
    );
  };

  const handleDateRange = (newRange) => {
    dispatch(setDateRange(newRange));
  };

  return (
    <div className='flex justify-between gap-3 items-center pb-5 max-md:flex-col'>
      <div className='flex items-center gap-3 max-md:flex-wrap'>
        <DatePicker handleSetDate={handleDateRange} selectedDate={selectedDate} />
        <CommonFilter
          name='Advertisers'
          items={advertisers}
          selectedItems={selectedAdvertisers}
          selectFunc={selectAdvertiser}
          selectAllFunc={selectAllAdvertisers}
        />
        <CommonFilter
          name='Sources'
          items={sources}
          selectedItems={selectedSource}
          selectFunc={selectSource}
          selectAllFunc={selectAllSources}
        />
        <CommonFilter
          name='Counties'
          items={countries}
          selectedItems={selectedCountry}
          selectFunc={selectCountry}
          selectAllFunc={selectAllCountries}
        />
      </div>
      <div className='flex items-center gap-5 max-md:mr-auto'>
        <ApplyButton applyFunc={applyFunc} isPaginate={false}  />
        <ResetButton resetFunc={resetFunc} />
      </div>
    </div>
  );
};

export default FiltersRow;
